// What the phone tells the Khronos Timer each second (KhronosFirmware HR
// faces): strap heart rate, bike or rower power, and the person's zone floors
// so the panel can colour HR the same way the app does. Pure, so it can be
// tested without Bluetooth; the 1 Hz loop lives in hooks/useTimerMetricsRelay.

import { zoneFloors } from "./heartRateZones";

/**
 * @param {{ bpm?: number|null, watts?: number|null, hrBasis?: object|null }} input
 *   bpm / watts are fresh readings (null when the sensor is quiet); hrBasis is
 *   heartRateBasis(profile).
 * @returns {null | { v: 1, hr_bpm?: number, watts?: number, zones?: number[] }}
 *   null when there is nothing to send.
 */
export function buildMetricsReport({ bpm = null, watts = null, hrBasis = null } = {}) {
  const hr = Number(bpm);
  const w = Number(watts);
  const hasHr = bpm != null && Number.isFinite(hr) && hr > 0;
  const hasW = watts != null && Number.isFinite(w) && w >= 0;
  if (!hasHr && !hasW) return null;
  return {
    v: 1,
    ...(hasHr ? { hr_bpm: Math.round(hr) } : {}),
    ...(hasW ? { watts: Math.round(w) } : {}),
    ...(hasHr && hrBasis ? { zones: zoneFloors(hrBasis) } : {}),
  };
}
